/**
 * Énumération des statuts de contrat d'achat pouvant être remontés.
 */
export enum StatutContratAchat {
    NonFerme = 1,
    Ferme = 2,
    Signe = 3,
    EnService = 4
}
